import { useTranslation } from 'react-i18next'
import { setLanguage } from '../i18n'

// Expanded: ES | EN segmented switch. Collapsed: a badge showing the CURRENT
// language; clicking it switches to the other language (see title/aria-label).
export default function LanguageToggle({ collapsed = false }) {
  const { t, i18n } = useTranslation()
  const lng = i18n.language === 'en' ? 'en' : 'es'

  if (collapsed) {
    const other = lng === 'es' ? 'en' : 'es'
    return (
      <button
        onClick={() => setLanguage(other)}
        title={`Switch to ${other.toUpperCase()}`}
        aria-label={`Switch to ${other.toUpperCase()}`}
        className="flex items-center justify-center w-8 h-8 mx-auto rounded-lg text-xs font-semibold text-gray-500 hover:bg-gray-100 hover:text-gray-800 transition-colors"
      >
        {lng.toUpperCase()}
      </button>
    )
  }

  return (
    <div role="group" aria-label={t('nav:language')} className="flex items-center gap-1 px-2 py-1.5">
      {['es', 'en'].map(code => (
        <button
          key={code}
          onClick={() => setLanguage(code)}
          aria-pressed={lng === code}
          className={`flex-1 text-xs font-semibold py-1 rounded-md transition-colors ${
            lng === code
              ? 'bg-gray-900 text-white'
              : 'text-gray-500 hover:bg-gray-100 hover:text-gray-800'
          }`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  )
}
